import { motion } from "framer-motion";
import { Search, MessageSquare, BookOpen, Briefcase, GraduationCap, Globe } from "lucide-react";

const features = [
  {
    icon: Search,
    title: "Find Free Programs",
    description: "Browse curated free education and skill programs from government and global sources.",
  },
  {
    icon: MessageSquare,
    title: "WhatsApp Knowledge Bank",
    description: "Search and share curated educational messages. Copy-paste ready for WhatsApp.",
  },
  {
    icon: BookOpen,
    title: "Simple Guidance",
    description: "Clear explanations of options after 12th, how to apply, and what to avoid.",
  },
  {
    icon: Briefcase,
    title: "Job & Apprenticeship Focus",
    description: "Programs that may lead to jobs, apprenticeships, or provider-issued certifications.",
  },
  {
    icon: GraduationCap,
    title: "Eligibility Clarity",
    description: "Know exactly who can apply, from where, and what documents are needed.",
  },
  {
    icon: Globe,
    title: "India + Global",
    description: "Free programs accessible to Indian residents from both domestic and international sources.",
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Everything You Need to Start
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We simplify the complex world of free education opportunities so you can focus on learning.
          </p>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={item}
              className="group p-6 rounded-2xl bg-gradient-card border border-border hover:shadow-card transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <feature.icon className="h-6 w-6 text-primary group-hover:text-primary-foreground" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
